import type React from 'react';
import { useForm, Controller } from 'react-hook-form';


import { Stack } from 'ui/stack';
import { Radio } from 'ui/radio';
import { RadioGroup } from 'ui/radio-group';

import { CLIENTS_STATUSES_FORM_FIELDS as statuses } from 'containers/admin/clients/client/forms/filter-status-form/filter-status-form.constants';
import type { ClientStatusFilterValue } from 'containers/admin/clients/client/forms/filter-status-form/filter-status-form.constants';

interface FilterStatusFormProps {
  status: ClientStatusFilterValue | string;
  onClick: (value: ClientStatusFilterValue | string | undefined) => void;
}

interface FilterStatusFormValues {
  status: ClientStatusFilterValue | string;
}

const FilterStatusForm = ({
  status,
  onClick,
}: FilterStatusFormProps): React.JSX.Element => {
  const { control } = useForm<FilterStatusFormValues>({
    mode: 'onChange',
  });

  return (
    <Stack
      direction="row"
      sx={{ alignItems: 'center', py: 0.75 }}
      data-testid="filter-status-section"
    >
      <span
        id="clients-statuses-label"
        className="w-28 md:w-32 mr-2 md:mr-4 font-semibold text-sm md:text-base"
      >
        Filter by Status
      </span>

      <Stack direction="row" sx={{ alignItems: 'center' }}>
        <Controller
          name="status"
          control={control}
          render={({ field }) => (
            <RadioGroup
              aria-labelledby="clients-statuses-label"
              row
              size="small"
              name={field.name}
              value={status}
              onChange={(_event, value) => {
                onClick(value);
                field.onChange(value);
              }}
              onBlur={field.onBlur}
              ref={field.ref}
            >
              {statuses.map(({ label, labelFor, key, radioValue }) => (
                <Radio
                  key={key}
                  value={radioValue}
                  label={label}
                  id={labelFor}
                  data-testid={`filter-status-${labelFor}`}
                />
              ))}
            </RadioGroup>
          )}
        />
      </Stack>
    </Stack>
  );
};

export default FilterStatusForm;
